import { render, staticRenderFns } from "./TheUserMain.vue?vue&type=template&id=cca54b24&"
import script from "./TheUserMain.vue?vue&type=script&lang=js&"
export * from "./TheUserMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports